var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1668 15.2168L13.1835 12.2335C14.6835 10.2835 14.5335 7.4668 12.7335 5.68346C11.7502 4.70013 10.4835 4.2168 9.20018 4.2168C7.91685 4.2168 6.65018 4.70013 5.66685 5.68346C3.71685 7.63346 3.71685 10.8001 5.66685 12.7501C6.65018 13.7335 7.91685 14.2168 9.20018 14.2168C10.2668 14.2168 11.3335 13.8835 12.2168 13.2001L15.2168 16.1668C15.3502 16.3001 15.5168 16.3668 15.7002 16.3668C15.8668 16.3668 16.0502 16.3001 16.1835 16.1668C16.4335 15.9168 16.4335 15.4835 16.1668 15.2168ZM9.21685 12.8668C8.23351 12.8668 7.33351 12.4835 6.63351 11.8001C5.21685 10.3835 5.21685 8.0668 6.63351 6.63346C7.31685 5.95013 8.23351 5.5668 9.21685 5.5668C10.2002 5.5668 11.1002 5.95013 11.8002 6.63346C12.5002 7.3168 12.8668 8.23346 12.8668 9.2168C12.8668 10.2001 12.4835 11.1001 11.8002 11.8001C11.1168 12.5001 10.1835 12.8668 9.21685 12.8668Z",
    fill: "#9599A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a53d2dbc9c12a0c751829a05d7f1df08.svg";
export { ForwardRef as ReactComponent };